import { render, staticRenderFns } from "./OrderParts.vue?vue&type=template&id=45421110&scoped=true&"
import script from "./OrderParts.vue?vue&type=script&lang=ts&"
export * from "./OrderParts.vue?vue&type=script&lang=ts&"
import style0 from "./OrderParts.vue?vue&type=style&index=0&id=45421110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45421110",
  null
  
)

export default component.exports